import urljoin from 'url-join';

const DICTIONARY_URL = 'static/ospd4.json';
const MAX_LETTER_EXTENSIONS = 3;
const LOADING_CHUNK_SIZE = 10000;

export function getLetterCounts(word) {
  const histogram = {};
  for (let i = 0; i < word.length; i += 1) {
    const letter = word.charAt(i);
    if (!histogram[letter]) {
      histogram[letter] = 0;
    }
    histogram[letter] += 1;
  }
  return histogram;
}

export function loadDictionary(commit) {
  const url = urljoin(window.location.href.replace('#', ''), DICTIONARY_URL);
  return new Promise((resolve) => {
    fetch(url)
      .then(res => res.json())
      .then((words) => {
        const dictionary = {};
        const numWords = words.length;
        let numLoadedWords = 0;

        function loadWords() {
          const fractionLoaded = numLoadedWords / numWords;
          commit('setLoadedPercent', Math.floor(100.0 * fractionLoaded));
          const max = Math.min(numWords, numLoadedWords + LOADING_CHUNK_SIZE);
          for (let i = numLoadedWords; i < max; i += 1) {
            const word = words[i];
            const length = word.length;
            if (!dictionary[length]) {
              dictionary[length] = [];
            }
            dictionary[length].push({
              counts: getLetterCounts(word),
              word,
            });
          }

          numLoadedWords += max - numLoadedWords;
          if (numLoadedWords === numWords) {
            setTimeout(() => {
              resolve(dictionary);
            }, 1);
          } else {
            setTimeout(loadWords, 1);
          }
        }
        setTimeout(loadWords, 1);
      });
  });
}


export function searchDictionary(dictionary, word) {
  const length = word.length;
  const counts = getLetterCounts(word);
  const letters = Object.keys(counts);

  return new Promise((resolve) => {
    const extensions = [];
    for (let lengthOffset = 1; lengthOffset <= MAX_LETTER_EXTENSIONS; lengthOffset += 1) {
      const candidates = dictionary[length + lengthOffset];
      if (candidates) {
        const results = candidates
          .filter(candidate => letters.every(l => candidate.counts[l] >= counts[l]))
          .map(candidate => candidate.word);
        extensions.push(results);
      }
    }
    resolve(extensions);
  });
}



// WEBPACK FOOTER //
// ./src/store/dict.js